import { useWsmPlugin } from "./useWsmPlugin";
import useSWR from "swr";
import useBoltTypeStore from "./useBoltTypeStore";

const usePairedDevices = () => {
  const { sensorManagerPlugin } = useWsmPlugin();

  const { getAllStoredBoltTypes, storeBoltType, deleteStoredBoltType } = useBoltTypeStore();

  const {
    data: devices,
    error: devicesError,
    isLoading: devicesLoading,
    mutate: mutateDevices,
  } = useSWR(
    () => ["getDevices"],
    async () => {
      const devices = (await sensorManagerPlugin?.getDevices())?.devices;
      if (devices) {
        Object.keys(getAllStoredBoltTypes()).forEach((appToken) => {
          if (devices.every((device) => device.appToken !== appToken)) {
            deleteStoredBoltType(appToken);
          }
        });
        devices.forEach((device) => {
          if (device.boltType && device.appToken) {
            storeBoltType(device.appToken, device.boltType);
          }
        });
      }
      return devices;
    }
  );

  return {
    devices,
    devicesError,
    devicesLoading,
    mutateDevices,
  };
};

export default usePairedDevices;
